/**
 * subscriptions-widget-labels.js
 *
 * The Shopify Subscriptions app embed renders each delivery interval using the
 * selling plan's `name`, which Shopify auto-generates as
 * "Deliver every 2 weeks, 15% off". The percentage is already stated once on
 * the parent "Subscribe and save 15%" row, so repeating it on all six lines is
 * redundant and forces every label to wrap on narrow viewports.
 *
 * Those names are not editable in the Subscriptions app (verified 2026-07-29),
 * and the selling plan group is owned by that app, so the Admin API cannot
 * rewrite them either. This trims the suffix in the DOM instead.
 *
 * Only text inside the widget's interval list is touched. If Shopify ever makes
 * the plan names editable, delete this file and the tag that loads it.
 *
 * Revisions:
 * 2026-07-29 - Created for the Koinonia subscriptions launch.
 */
(function () {
  'use strict';

  var ROOT = '.subscriptions_app_embed_block';
  var LIST = '.shopify_subscriptions_app_block_label_children';
  var SUFFIX = /,\s*\d+(?:\.\d+)?%\s*off\s*$/i;

  function trim(root) {
    var lists = root.querySelectorAll(LIST);
    for (var i = 0; i < lists.length; i++) {
      var walker = document.createTreeWalker(lists[i], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var original = node.nodeValue;
        if (!original || original.indexOf('%') === -1) continue;
        var next = original.replace(SUFFIX, '');
        // Guard against recursion: only write when the value actually changes.
        if (next !== original) node.nodeValue = next;
      }
    }
  }

  function start() {
    var root = document.querySelector(ROOT);
    if (!root) return;

    trim(root);

    // The app hydrates asynchronously and re-renders on variant change, so keep
    // watching. trim() is idempotent, so re-entry from our own writes settles.
    new MutationObserver(function () {
      trim(root);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
